<template>

    <v-container class="align-center flex-row mb-6 pa-0">

        <p class="text-headline-small mb-4">Identificazione</p>

        <v-select v-model="properties.luposegni_id" :items="segni" label="Segni" item-title="label" hide-details
            class="mb-6" />
    </v-container>


    <v-card class="ma-0 mb-6 pa-3" :border="true" flat  v-if="properties.luposegni_id == 9">
        <p class="text-headline-small">Pelo</p>
        <SamplePickFur v-model:properties="properties" :timestamp="properties.real_timestamp" />

    </v-card>

    <v-card class="ma-0 mb-6 pa-3" :border="true" flat  v-if="properties.luposegni_id == 8">

        <p class="text-headline-small">Fatta</p>
        <FecesPick v-model:properties="properties" :timestamp="properties.real_timestamp" />

    </v-card>

    <v-card class="ma-0 mb-6 pa-3" :border="true" flat  v-if="properties.luposegni_id == 10">
        <p class="text-headline-small">Predazione</p>

        <PredationEvidences v-model:properties="properties" />
    </v-card>


    <v-card class="ma-0 mb-6 pa-3" :border="true" flat>
    <p class="text-headline-small">Quantità</p>

    <PopulationCounter v-model:properties="properties" />

  </v-card>


    <SegnalazioneCommon v-model="properties" />


</template>

<script setup>


import SegnalazioneCommon from "@/reports/components/SegnalazioneCommon";
import baseData from '@/assets/catalog/TrackerForms.json'
import { computed, onMounted, watch } from 'vue'


import SamplePickFur from "@/reports/components/SamplePickFur";
import FecesPick from "@/reports/components/FecesPick";
import PredationEvidences from "@/reports/components/PredationEvidences";
import PopulationCounter from "@/reports/components/PopulationCounter";


const properties = defineModel()

const props = defineProps({
    "isNew": {
        type: Boolean,
        default: false
    }
})

const segni = baseData.lookup.luposegni

const loadDefaults = () => {

    properties.value.luposegni_id = baseData.lookup.luposegni[0].value

    // properties.value.predaspeciefauna = null
    // properties.value.consumato = null
    // properties.value.predasesso = null
    // properties.value.predagiovane = null
    // properties.value.predanote = ""

}


const totalecontofauna = computed(() => {

    if (!properties) return 0

    let tot = 0
    tot = tot + (properties?.value?.q_male || 0)
    tot = tot + (properties?.value?.q_female || 0)
    tot = tot + (properties?.value?.q_young || 0)
    tot = tot + (properties?.value?.q_kid || 0)
    tot = tot + (properties?.value?.q_undefined || 0)

    // console.log("totalecontofauna called") 
    return tot
})


watch(() => properties.value.segni_id, (newVal,) => {
    // carcassa == 10 
    // fatta == 8 
    // pelo == 9 

    if (newVal !== 10) {  // non carcassa
        delete properties.value.predato
        delete properties.value.predaspeciefauna_id
        delete properties.value.consumato
        delete properties.value.predasesso_id
        delete properties.value.predagiovane
        delete properties.value.predanote
    }

    if (newVal !== 8) {  // non fatta
        delete properties.value.fatta_codice
        delete properties.value.prelevato
        delete properties.value.prelevato_codice
        delete properties.value.analisi_genetica
        delete properties.value.analisi_dieta
    }

    if (newVal !== 9) {  // non pelo
        delete properties.value.prelevato
        delete properties.value.prelevato_codice
        delete properties.value.analisi_genetica
    }
})


onMounted(() => {

    // console.log("mounted")
    if (totalecontofauna.value === 0) {
        properties.value.q_male = 0
    }
    if (props.isNew) {
        properties.value.label = "Lupo"

        loadDefaults()
    }

})
</script>
